import { useTranslation } from 'react-i18next';
import type { LandingLocale } from '../i18n';
import { setLandingLocale } from '../i18n';

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const current = (i18n.language?.startsWith('en') ? 'en' : 'el') as LandingLocale;

  const select = (lang: LandingLocale) => {
    setLandingLocale(lang);
  };

  return (
    <div className="lang-switch" role="group" aria-label={t('nav.language')}>
      <button
        type="button"
        className={`lang-switch-btn${current === 'el' ? ' is-active' : ''}`}
        onClick={() => select('el')}
        lang="el"
      >
        EL
      </button>
      <button
        type="button"
        className={`lang-switch-btn${current === 'en' ? ' is-active' : ''}`}
        onClick={() => select('en')}
        lang="en"
      >
        EN
      </button>
    </div>
  );
}
